module.exports = __webpack_public_path__ + "static/media/computer-classic.6706d5c2.svg";